export default __webpack_public_path__ + "images/QD.81ac562.png";